import { ICardElementWithChildren } from "backend/model/model";
import ProgressBar from "design/components/progress/ProgressBar";
import InitiativeHeading from "design/components/texts/InitiativeHeading";
import { getPropsFromContent, IDisplaySeries } from "design/types";
import React from "react";
import CardWrapper from "../InitiativeDetailsCardWrapper";
import useProgressCardStyles from "./InitiativeProgressCardStyles";

type Props = {
  data: ICardElementWithChildren;
  display: IDisplaySeries;
  series?: Array<IDisplaySeries>;
};

const InitiativeProgressCard = (props: Props) => {
  const { data, series } = props;
  const classes = useProgressCardStyles();
  const content = getPropsFromContent(data, props.display);
  return (
    <div className={classes.container}>
      <InitiativeHeading>Progress</InitiativeHeading>
      <CardWrapper color="696969" period={data.period?.name || ""} title="">
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{ width: "75%", display: "flex", justifyContent: "center" }}
          >
            <ProgressBar
              value={content.value}
              title={content.title}
              barColor={content.bgColor}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            {series?.map((ser) => {
              const content = getPropsFromContent(data, ser);
              return (
                <h3 key={content.title}>
                  {content.title} {content.prettyvalue}
                </h3>
              );
            })}
          </div>
        </div>
      </CardWrapper>
    </div>
  );
};

export default InitiativeProgressCard;
